import { alpha } from '@mui/material/styles';

import { common, primary } from './palette';

interface GradientOptions {
  angle?: number;
  opacity?: number;
  colors?: string[];
  stops?: number[];
  addTransparentStop?: boolean;
}

/**
 * Generates a custom linear gradient string.
 * This utility allows for configurable colors, stops, angle, opacity,
 * and an optional final transparent stop.
 *
 * @param options - Configuration for the gradient.
 * @returns A CSS linear-gradient string.
 */
function main(options: GradientOptions = {}): string {
  const { angle = 340, opacity = 0.5, addTransparentStop = false } = options;

  // Use provided colors or fall back to defaults using imported palette colors
  const colors = options.colors || [common.white, '#D1F4FF', primary.lighter];
  const stops = options.stops || [5, 60, 100];

  if (colors.length !== stops.length) {
    console.error('Gradient error: The number of colors must match the number of stops.');
    return 'none';
  }

  const colorStops = colors
    .map((color, index) => `${alpha(color, opacity)} ${stops[index]}%`)
    .join(', ');

  const finalGradient = addTransparentStop ? `${colorStops}, transparent 100%` : colorStops;

  return `linear-gradient(${angle}deg, ${finalGradient})`;
}

export const customGradients = {
  main,
};

export type CustomGradients = typeof customGradients;
